import styled from 'styled-components';

const ListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.small || '0.625rem'} 0;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.small / 2 || '0.3125rem'};
  }
`;

export default ListItem;
